import { useNavigate } from "react-router-dom";
import { componentState } from "../../../../atoms/componentState";
import { useRecoilState, useSetRecoilState } from "recoil";
import { useState } from "react";
import { Box, Button, Flex } from "@chakra-ui/react";
import { FaPlus } from "react-icons/fa";
import { CADASTROPLANOSRECORRENCIA } from "../../../../constants/paths";
import TablePlanosRecorrencia from "./tablePlanosRecorrencia";
import { JWTToken } from "../../listaDeVendas/SalesList";
import jwt_decode from "jwt-decode";
import { customColors } from "../../../../atoms/customColors";
import { permissions } from "../../../../atoms/permissions";

export default function ListagemPlanos() {
  const setHeaderLocation = useSetRecoilState(componentState);
  setHeaderLocation("Planos para Assinaturas");
  const navigate = useNavigate();

  const [perms] = useRecoilState(permissions);
  const [colors] = useRecoilState(customColors);

  const token = window.localStorage.getItem("token");
  const jwtToken: JWTToken = jwt_decode(token || "");
  const idCliente = Number(jwtToken.idCliente);

  const initialValues = {
    clientFilter: idCliente,
  };
  const [filtros, setFiltros] = useState(initialValues);

  let loginPermissoes: number[] = [];
  if (token && typeof token === "string" && token.includes(".")) {
    try {
      const decoded: JWTToken = jwt_decode(token);
      if (decoded.loginPermissoes) {
        loginPermissoes = JSON.parse(decoded.loginPermissoes);
      }
    } catch (error) {
      console.error("Error decoding JWT or parsing loginPermissoes:", error);
    }
  }

  function temPermissao(
    userPerm: number | null,
    clientePerm: boolean,
    permArray: number[] = []
  ): boolean {
    if (!permArray.length || userPerm === null) {
      return clientePerm ?? false;
    }
    const permUser = permArray.includes(userPerm);
    const permCliente = clientePerm ?? false;
    return permUser && permCliente;
  }

  const hasPermission = temPermissao(
    null,
    perms.some(
      (perm: any) => perm.idPermissoes === 1 || perm.idPermissoes === 17
    ),
    loginPermissoes
  );

  return (
    <Flex flexDir={"column"} height="100%" width="100%">
      <Box
        width={"99.8%"}
        bgColor={colors.WHITE}
        height={"fit-content"}
        shadow={"md"}
        mt={"0.2%"}
        mx="auto"
        py={3}
        px={3}
      >
        <Flex
          justifyContent={"flex-end"}
          flexDirection={"row"}
          my={"auto"}
          px={8}
        >
          {hasPermission && (
            <Button
              leftIcon={<FaPlus />}
              style={{ color: "white" }}
              onClick={() => {
                navigate(CADASTROPLANOSRECORRENCIA);
              }}
              _hover={{ bg: "#4B4B57" }}
              bgColor={colors.BLUEMONEDDBUTTONS}
            >
              Adicionar Planos para Vendas
            </Button>
          )}
        </Flex>
      </Box>
      <Box
        w={"99.8%"}
        height={"80vh"}
        bgColor={colors.WHITE}
        mt={"0.5%"}
        shadow={"md"}
        mx="auto"
        py={3}
        px={3}
      >
        <TablePlanosRecorrencia idCliente={idCliente} />
      </Box>
    </Flex>
  );
}
